import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

import { Avatar } from '../Avatar';

interface EmployeeBadgeProps {
  name: string;
  globalId?: string;
  date?: string;
  location?: string;
  status?: string;
  size?: 'sm' | 'md' | 'lg';
  showDate?: boolean;
  showLocation?: boolean;
  showStatus?: boolean;
  avatarSize?: 'sm' | 'md' | 'lg';
  avatarClassName?: string;
  className?: string;
}

export function EmployeeBadge({
  name,
  globalId,
  date,
  location,
  status,
  size = 'md',
  showDate = true,
  showLocation = false,
  showStatus = false,
  avatarSize,
  avatarClassName = '',
  className = ''
}: EmployeeBadgeProps) {
  const getAvatarSize = () => {
    switch (size) {
      case 'sm':
        return 'w-6 h-6';
      case 'lg':
        return 'w-12 h-12';
      default:
        return 'w-8 h-8';
    }
  };

  const getTextVariant = (): 'body-sm-medium' | 'body-md-medium' => {
    switch (size) {
      case 'sm':
        return 'body-sm-medium';
      case 'lg':
        return 'body-md-medium';
      default:
        return 'body-sm-medium';
    }
  };

  const getDateVariant = (): 'metadata-sm-regular' => {
    return 'metadata-sm-regular';
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${getAvatarSize()} ${avatarClassName}`.trim()}>
        <Avatar globalId={globalId || ''} name={name} size={avatarSize} />
      </div>
      <div className="flex flex-col">
        <Typography
          variant={getTextVariant()}
          color="dark"
          className="text-gray-900">
          {name}
        </Typography>
        {(showDate || showLocation || showStatus) && (
          <Typography
            variant={getDateVariant()}
            color="light"
            className="text-gray-500">
            {showLocation && location && `${location} • `}
            {showDate && date && date}
            {showStatus && status && status}
          </Typography>
        )}
      </div>
    </div>
  );
}
